import React from 'react';
import { connect } from 'react-redux';
import CustomDropdown from 'components/CustomDropdown';
import * as selectors from 'containers/AccessControl/selectors';
import moment from 'moment';
import { getKeyByValueAsNumber } from 'utils/functions';
import { PeriodEndWeekType } from 'utils/types';

const getWeeksLabels = endWeek => {
  return {
    2: `2 Weeks ending ${moment(endWeek, 'YYYY-MM-DD').format('MM/DD/YYYY')}`,
    4: `4 Weeks ending ${moment(endWeek, 'YYYY-MM-DD').format('MM/DD/YYYY')}`,
    12: `12 Weeks ending ${moment(endWeek, 'YYYY-MM-DD').format('MM/DD/YYYY')}`,
    24: `24 Weeks ending ${moment(endWeek, 'YYYY-MM-DD').format('MM/DD/YYYY')}`,
    52: `52 Weeks ending ${moment(endWeek, 'YYYY-MM-DD').format('MM/DD/YYYY')}`
  };
};

interface Props {
  currentWeeks: number;
  onSelect(weeks: number): void;
  endWeek: PeriodEndWeekType;
}

const DataPeriodSelect: React.FC<Props> = ({ currentWeeks, onSelect, endWeek }) => {
  const WeeksLabels = getWeeksLabels(endWeek.spins ? endWeek.spins : endWeek.nielsen);
  return (
    <CustomDropdown
      items={Object.values(WeeksLabels)}
      title={WeeksLabels[currentWeeks]}
      onSelect={item => onSelect(getKeyByValueAsNumber(WeeksLabels, item))}
    />
  );
};

const mapStateToProps = state => ({
  endWeek: selectors.periodEndWeekSelector(state)
});

export default connect(mapStateToProps)(DataPeriodSelect);
